import { gql } from '@apollo/client';

export const PARTNER_EXTRA_INFO_QUERY = gql`
  query partnerExtraInfos($documentId: Int!, $siteId: Int!, $partnerId: Int!) {
    partnerExtraInfos(documentId: $documentId, siteId: $siteId, partnerId: $partnerId) {
    data {
      sections {
        columns {
          caption
          propertyName
          propertyType
          required
          propertyCode
        }
        extraInformationId
        jsonData
        name
        display
        textArea
      }
    }
    partnerId
  }
}
`;

